/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'



/** @type {import('Simple/types.js').View} */
export default function Notes({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Notes",
  onChange,
  isInvalid
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let profilePatientNotesValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'notes',
})
let profilePatientNotesIsValidData = fromData.useDataIsValid({ viewPath,
context: 'profile_patient',
path: 'notes',
validate: fromValidate.textInput,
})
let profilePatientNotesChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'notes',
})
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 text="Notes"
/>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={dtSpaceXxs}
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 height="auto"
 resize={true}
 data="profile_patient.notes"
 validate="/Data/validate.js textInput"
 onChange={profilePatientNotesChangeData}
 value={profilePatientNotesValueData}
 isInvalid={!profilePatientNotesIsValidData}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}